<template>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col>
            <div class="font-weight-bold mt-6 title-page">Cadastro</div>
            <br>
            <div class="subtitle-1 text--secondary mb-n3">Escolha o tipo de cadastro.</div>
  
            <div class="mt-4 mb-2">
              <v-tabs v-model="tab" background-color="primary" dark>
                <v-tab>
                  <v-icon left>mdi-account</v-icon>
                  Credor
                </v-tab>
                <v-tab>
                  <v-icon left>mdi-account-tie</v-icon>
                  Procurador
                </v-tab>
              </v-tabs>
            </div>
  
            <br>
            <p>Preencha os campos abaixo para realizar o cadastro.</p>
  
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <CredorForm />
              </v-tab-item>
  
              <v-tab-item>
                <Procurador />
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </template>
  
  <script>
  import CredorForm from './componentsRegister/CreditorForm.vue'
  import Procurador from './componentsRegister/LawyerForm.vue'
  
  export default {
    components: {
      CredorForm,
      Procurador
    },
    data() {
      return {
        tab: 0
      }
    },
   
  }
  </script>
  
  
